module.exports = __webpack_public_path__ + "static/media/ccs-black.7a5e1ff7.svg";